import { RUNTIME_CONFIG_URL } from '@framework/constants/app';
import { isWindowDefined } from '@framework/utils';

import type { RuntimeConfig } from '@components/pages/other/RuntimeContext/Runtime.context';

export const loadRuntimeConfig = async (
    headers?: Record<string, string>
): Promise<RuntimeConfig> => {
    if (isWindowDefined()) {
        const res = await fetch(RUNTIME_CONFIG_URL);
        return res.json();
    }

    if (!headers) {
        throw new Error('Headers are required to load runtime config on the server side');
    }

    const protocol = headers['x-forwarded-proto'] || 'https';
    const host = headers['x-forwarded-host'] || headers.host;
    const BASE_URL = `${protocol}://${host}`;

    const res = await fetch(`${BASE_URL}${RUNTIME_CONFIG_URL}`);
    return res.json();
};
